<template>
  <div>
    <!-- ===================== MOBILE CARD LIST (< 960px) ===================== -->
    <div class="d-md-none movements-mobile-list mt-2 px-2 pb-4">
      <v-progress-linear v-if="loading" indeterminate color="red" class="mb-2" />

      <div
        v-for="(item, index) in parts"
        :key="item._id"
        class="movements-mobile-card"
        :class="{
          'movements-mobile-card--selected': index === activeRow,
        }"
        @click="activeRow = activeRow === index ? null : index"
      >
        <div class="movements-mobile-card__main">
          <div class="movements-mobile-card__media">
            <button
              type="button"
              class="movements-mobile-card__image-btn"
              @click.stop="showImages(item.images)"
            >
              <img :src="getPartImageSrc(item)" class="movements-mobile-card__img" />
            </button>
            <button
              v-if="getPartQrId(item)"
              type="button"
              class="movements-mobile-card__qr-btn"
              @click.stop="openPartQr(item)"
            >
              {{ getPartQrId(item) }}
            </button>
          </div>

          <div class="movements-mobile-card__info">
            <div class="movements-mobile-card__info-top">
              <div
                v-if="
                  ($store.getters.role === 'LekoAdmin' ||
                    $store.getters.role === 'SuperAdmin') &&
                  item.institution_id?.title
                "
                class="mb-1"
              >
              <v-chip size="x-small">
                {{ item.institution_id.title }}
                </v-chip>
              </div>
              <v-btn
                v-if="item.date_created"
                color="black"
                variant="outlined"
                size="small"
                class="movements-mobile-card__date mb-1"
                readonly
                @click.stop
              >
                {{ formatDate(item.date_created) }}
              </v-btn>
              <div
                v-if="item.infoCar?.description?.descriptionId?.group"
                class="text-caption font-weight-bold"
              >
                {{
                  item.infoCar.description.descriptionId.group[
                    $store.getters.language
                  ]
                }}
              </div>
              <div
                v-if="item.infoCar?.description?.descriptionId?.category"
                class="text-caption text-grey-darken-1"
              >
                {{
                  item.infoCar.description.descriptionId.category[
                    $store.getters.language
                  ]
                }}
              </div>
              <div
                v-if="item.infoCar?.description?.descriptionId?.title"
                class="font-weight-bold text-primary text-body-2"
              >
                {{
                  item.infoCar.description.descriptionId.title[
                    $store.getters.language
                  ]
                }}
                <span
                  v-if="item.infoCar.description.positionCode"
                  class="text-caption text-grey font-weight-regular"
                >
                  {{ getPosition(item.infoCar.description.positionCode) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <v-btn
          v-if="getMovementStatusMeta(item).label"
          :color="getMovementStatusMeta(item).color"
          variant="outlined"
          size="large"
          class="movements-mobile-card__status"
          @click.stop="movement(item)"
        >
          {{ getMovementStatusMeta(item).label }}
        </v-btn>
      </div>

      <v-alert
        v-if="!loading && parts.length < 1"
        type="info"
        variant="tonal"
        class="mt-2"
      >
        No data available.
      </v-alert>
    </div>
    <!-- ===================================================================== -->

    <div class="movements-table-host pb-2">
      <v-data-table-server
      v-model:options="pagination"
      :headers="
        $store.getters.role === 'LekoAdmin' ||
        $store.getters.role === 'SuperAdmin'
          ? headersAdmin
          : headers
      "
      :items="parts"
      :page="pagination.page"
      :items-length="totalItems"
      :loading="loading"
      class="elevation-1 nowrap-headers"
      :items-per-page="pagination.itemsPerPage"
      :items-per-page-options="[
        { value: 5, title: '5' },
        { value: 10, title: '10' },
        { value: 25, title: '25' },
        { value: 50, title: '50' },
      ]"
      items-per-page-text="Rows per page"
      @update:options="updatePagination"
    >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>
      <template #item="{ item, index }">
        <tr
          :class="{ tableRowColorSelected: index === activeRow }"
          class="tableRowColor"
          @click="activeRow = activeRow === index ? null : index"
        >
          <!----------------------------------------STATUS----------------------------------------->
          <td>
            <v-row class="text-center justify-center pl-4 pr-2">
              <v-btn
                v-if="item.status === 1"
                small
                color="success"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.entered") }}
              </v-btn>
              <v-btn
                v-if="item.status === 2"
                small
                color="warning"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.returned") }}
              </v-btn>
              <v-btn
                v-if="item.status === 2.1"
                small
                color="warning"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.returned_shop") }}
              </v-btn>
              <v-btn
                v-if="item.status === 3"
                small
                color="info"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.re_entered") }}
              </v-btn>
              <v-btn
                v-if="item.status === 4"
                small
                color="info"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.found") }}
              </v-btn>
              <v-btn
                v-if="item.status === 5"
                small
                color="success"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.sold") }}
              </v-btn>
              <v-btn
                v-if="item.status === 6"
                small
                color="error"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.lost") }}
              </v-btn>
              <v-btn
                v-if="item.status === 6.1"
                small
                color="error"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.lost_shop") }}
              </v-btn>
              <v-btn
                v-if="item.status === 7"
                small
                color="error"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.damaged_inventory") }}
              </v-btn>
              <v-btn
                v-if="item.status === 8"
                small
                color="error"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.damaged_sales") }}
              </v-btn>
              <v-btn
                v-if="item.status === 8.1"
                small
                color="error"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.damaged_shop") }}
              </v-btn>
              <v-btn
                v-if="item.status === 9"
                small
                color="error"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.damaged_lost") }}
              </v-btn>
              <v-btn
                v-if="item.status === 0"
                small
                color="error"
                variant="outlined"
                @click="movement(item)"
              >
                {{ $t("parts.status.recycled") }}
              </v-btn>
            </v-row>
          </td>
          <!------------------------------------------ID------------------------------------------->
          <td v-if="item.old_id && item.old_id !== undefined">
            <v-row
              class="pointer ma-1 text-center justify-center d-block"
              @click="
                openQrDialog({
                  id: item.old_id,
                  type: 'inventory',
                  printed: item.printed,
                })
              "
            >
              <qr-code
                class="d-flex justify-center"
                :size="60"
                :text="item.old_id"
              />
              {{
                item.old_id.slice(item.old_id.length - 6, item.old_id.length)
              }}
            </v-row>
          </td>
          <td v-else class="text-xs">
            <v-row
              class="pointer ma-1 text-center justify-center d-block"
              @click="
                openQrDialog({
                  id: item._id,
                  type: 'inventory',
                  printed: item.printed,
                })
              "
            >
              <qr-code
                class="d-flex justify-center"
                :size="60"
                :text="item._id"
              />
              {{ item._id.slice(item._id.length - 4, item._id.length) }}
            </v-row>
          </td>
          <!--------------------------------------LEKO GROUP--------------------------------------->
          <td>
            <v-row column>
              <v-col>
                <span
                  v-if="
                    item.infoCar &&
                    item.infoCar.description &&
                    item.infoCar.description.descriptionId &&
                    item.infoCar.description.descriptionId.group
                  "
                  class="text-xs font-weight-bold"
                >
                  <!-- eslint-disable-next-line max-len -->
                  {{
                    item.infoCar.description.descriptionId.group[
                      $store.getters.language
                    ]
                  }}
                </span>
              </v-col>
            </v-row>
          </td>
          <!-----------------------------------------GROUP----------------------------------------->
          <td>
            <v-row>
              <v-col>
                <span
                  v-if="
                    item.infoCar &&
                    item.infoCar.description &&
                    item.infoCar.description.descriptionId &&
                    item.infoCar.description.descriptionId.category
                  "
                  class="text-xs font-weight-bold"
                >
                  <!-- eslint-disable-next-line max-len -->
                  {{
                    item.infoCar.description.descriptionId.category[
                      $store.getters.language
                    ]
                  }}
                </span>
              </v-col>
            </v-row>
          </td>
          <!-----------------------------------------TITLE----------------------------------------->
          <td class="text-xs pr-2 pl-2">
            <v-row>
              <v-col v-if="item.infoCar && item.infoCar.description">
                <span
                  v-if="
                    item.infoCar.description.descriptionId &&
                    item.infoCar.description.descriptionId.title
                  "
                  class="text-xs font-weight-bold"
                >
                  {{
                    item.infoCar.description.descriptionId.title[
                      $store.getters.language
                    ]
                  }}
                </span>
                <span
                  v-if="item.infoCar.description.positionCode"
                  class="text-xs"
                >
                  {{ getPosition(item.infoCar.description.positionCode) }}
                </span>
              </v-col>
            </v-row>
          </td>
          <!--------------------------------------INSTITUTION-------------------------------------->
          <td
            v-if="
              ($store.getters.role === 'LekoAdmin' ||
                $store.getters.role === 'SuperAdmin') &&
              item.institution_id
            "
            class="text-xs"
          >
            <v-chip>
              {{ item.institution_id.title }}
            </v-chip>
          </td>
          <td
            v-else-if="
              ($store.getters.role === 'LekoAdmin' ||
                $store.getters.role === 'SuperAdmin') &&
              !item.institution_id
            "
          />
          <!----------------------------------------PHOTOS----------------------------------------->
          <td>
            <v-row class="pl-2 pr-2">
              <img
                :src="
                  item.images && item.images.length > 0 && item.images[0].thumb
                    ? `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${item.images[0].thumb}`
                    : `https://portal.lekotech.com/logo_small.png`
                "
                class="ma-1 pointer"
                height="75"
                width="100"
                @click="showImages(item.images)"
              />
            </v-row>
          </td>
          <!-----------------------------------------DATE------------------------------------------>
          <td class="text-center text-truncate">
            <v-btn color="black" variant="outlined" small>
              {{ formatDate(item.date_created) }}
            </v-btn>
          </td>
          <!--------------------------------------------------------------------------------------->
        </tr>
        <tr v-if="parts && parts.length < 1">
          <td :colspan="headers.length" class="text-center pa-4">
            <v-alert type="info" border="left" color="red lighten-2" text>
              No data available.
            </v-alert>
          </td>
        </tr>
      </template>
    </v-data-table-server>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueQrCode from "vue-qr-generator"; // eslint-disable-line import/extensions

import getRequest from "../../api/getRequest";

export default {
  components: {
    "qr-code": VueQrCode,
  },
  props: ["search"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    loading: false,
    activeRow: null,
    pagination: {
      itemsPerPage: 5,
      page: 1,
      groupBy: ["date_created"],
      sortBy: [{ key: "date_created", order: "desc" }],
      sortDesc: [true],
    },
    totalItems: 0,
    parts: [],
    headers: [
      {
        title: "Status",
        sortable: true,
        key: "status",
      },
      {
        title: "ID",
        sortable: false,
        key: "",
      },
      {
        title: "",
        sortable: true,
        key: "leko_group",
      },
      {
        title: "Group",
        sortable: true,
        key: "group",
      },
      {
        title: "Title",
        sortable: true,
        key: "title",
      },
      {
        title: "Photos",
        sortable: false,
        key: "",
      },
      {
        title: "Date Created",
        sortable: true,
        key: "date_created",
      },
    ],
    headersAdmin: [
      {
        title: "Status",
        sortable: true,
        key: "status",
      },
      {
        title: "ID",
        sortable: false,
        key: "",
      },
      {
        title: "",
        sortable: true,
        key: "leko_group",
      },
      {
        title: "Group",
        sortable: true,
        key: "group",
      },
      {
        title: "Title",
        sortable: true,
        key: "title",
      },
      {
        title: "Institution",
        sortable: true,
        key: "institution_id",
      },
      {
        title: "Photos",
        sortable: false,
        key: "",
      },
      {
        title: "Date Created",
        sortable: true,
        key: "date_created",
      },
    ],
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    searchObject() {
      return this.$props.search;
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.searchObject.type === null) {
          this.getParts();
        } else if (this.searchObject.type === "regularSearch") {
          this.regularSearch(this.searchObject.data);
        } else if (this.searchObject.type === "advancedSearch") {
          this.advancedSearch(this.searchObject.data);
        } else {
          //
        }
      },
      deep: true,
    },
    searchObject: {
      handler(value) {
        if (value.type === null) {
          this.getParts();
        } else if (value.type === "regularSearch") {
          this.regularSearch(value.data);
        } else if (value.type === "advancedSearch") {
          this.advancedSearch(value.data);
        } else {
          //
        }
      },
    },
  },
  mounted() {
    this.getLocale();
  },
  methods: {
    getLocale() {
      this.headers[0].title = this.$t("parts.table.status");
      this.headers[1].title = this.$t("parts.table.qr_code");
      this.headers[2].title = this.$t("parts.table.leko_group");
      this.headers[3].title = this.$t("parts.table.group");
      this.headers[4].title = this.$t("parts.table.title");
      this.headers[5].title = this.$t("parts.table.images");
      this.headers[6].title = this.$t("parts.table.date_created");
      this.headersAdmin[0].title = this.$t("parts.table.status");
      this.headersAdmin[1].title = this.$t("parts.table.qr_code");
      this.headersAdmin[2].title = this.$t("parts.table.leko_group");
      this.headersAdmin[3].title = this.$t("parts.table.group");
      this.headersAdmin[4].title = this.$t("parts.table.title");
      this.headersAdmin[5].title = this.$t("parts.table.institution");
      this.headersAdmin[6].title = this.$t("parts.table.images");
      this.headersAdmin[7].title = this.$t("parts.table.date_created");
    },
    getParts() {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date_created",
        order: "desc",
      };
      getRequest(
        "/part/movements/datatable",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${sort.order === "desc"}`,
      )
        .then((response) => {
          this.$scrollToTop();
          this.loading = false;
          this.totalItems = response.count;
          this.parts = response.parts;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    regularSearch(data) {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date_created",
        order: "desc",
      };
      getRequest(
        "/part/movements/search/regular",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${
          sort.order === "desc"
        }&search_field=${data.searchField}&title_code=${
          data.titleCode
        }&title_code=${data.titleCode}&title_codes=${data.titleCodes}&type=${
          data.type
        }&language=${this.$store.getters.language}`,
      )
        .then((response) => {
          this.$scrollToTop();
          this.totalItems = response.count;
          this.parts = response.parts;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    advancedSearch(data) {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date_created",
        order: "desc",
      };
      getRequest(
        "/part/movements/search/advanced",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${
          sort.order === "desc"
        }&search_field=${data.searchField}&language=${
          this.$store.getters.language
        }&title_code=${data.titleCode}&title_codes=${data.titleCodes}&type=${
          data.type
        }&status=${data.advancedSearchFields.status}&start_date=${
          data.advancedSearchFields.startDate
        }&end_date=${data.advancedSearchFields.endDate}`,
      )
        .then((response) => {
          this.$scrollToTop();
          this.totalItems = response.count;
          this.parts = response.parts;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getPartQrId(item) {
      if (item.old_id) {
        return item.old_id.slice(item.old_id.length - 6, item.old_id.length);
      }
      if (item._id) {
        return item._id.slice(item._id.length - 4, item._id.length);
      }
      return "";
    },
    openPartQr(item) {
      if (item.old_id) {
        this.openQrDialog({
          id: item.old_id,
          type: "inventory",
          printed: item.printed,
        });
      } else {
        this.openQrDialog({
          id: item._id,
          type: "inventory",
          printed: item.printed,
        });
      }
    },
    getPartImageSrc(item) {
      if (item.images?.length > 0 && item.images[0].thumb) {
        return `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${item.images[0].thumb}`;
      }
      return "https://portal.lekotech.com/logo_small.png";
    },
    getMovementStatusMeta(item) {
      const status = item.status;
      if (status === 1) {
        return { label: this.$t("parts.status.entered"), color: "success" };
      }
      if (status === 2) {
        return { label: this.$t("parts.status.returned"), color: "warning" };
      }
      if (status === 2.1) {
        return {
          label: this.$t("parts.status.returned_shop"),
          color: "warning",
        };
      }
      if (status === 3) {
        return { label: this.$t("parts.status.re_entered"), color: "info" };
      }
      if (status === 4) {
        return { label: this.$t("parts.status.found"), color: "info" };
      }
      if (status === 5) {
        return { label: this.$t("parts.status.sold"), color: "success" };
      }
      if (status === 6) {
        return { label: this.$t("parts.status.lost"), color: "error" };
      }
      if (status === 6.1) {
        return { label: this.$t("parts.status.lost_shop"), color: "error" };
      }
      if (status === 7) {
        return {
          label: this.$t("parts.status.damaged_inventory"),
          color: "error",
        };
      }
      if (status === 8) {
        return {
          label: this.$t("parts.status.damaged_sales"),
          color: "error",
        };
      }
      if (status === 8.1) {
        return {
          label: this.$t("parts.status.damaged_shop"),
          color: "error",
        };
      }
      if (status === 9) {
        return { label: this.$t("parts.status.damaged_lost"), color: "error" };
      }
      if (status === 0) {
        return { label: this.$t("parts.status.recycled"), color: "error" };
      }
      return { label: "", color: "grey" };
    },
    movement(data) {
      this.$emit("movement", data);
    },
    openQrDialog(data) {
      this.$emit("qr", data);
    },
    showImages(images) {
      this.$emit("images", { type: "string", images });
    },
    updatePagination(options) {
      this.pagination = {
        ...options,
        itemsPerPage: options.itemsPerPage ? options.itemsPerPage : 5,
        groupBy:
          options.groupBy && options.groupBy.length
            ? options.groupBy
            : ["date_created"],
        sortBy:
          options.sortBy && options.sortBy.length
            ? options.sortBy
            : { key: "date_created", order: "desc" },
        sortDesc:
          options.sortDesc && options.sortDesc.length
            ? options.sortDesc
            : [true],
      };
      this.activeRow = null;
    },
    getPosition(code) {
      switch (code) {
        case "S001":
          return this.$t("left");
        case "S002":
          return this.$t("right");
        default:
          return "";
      }
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("LLL");
    },
  },
};
</script>

<style scoped>
@media (max-width: 959.98px) {
  .movements-table-host :deep(.v-table__wrapper),
  .movements-table-host :deep(.v-data-table__wrapper),
  .movements-table-host :deep(.v-data-table__wrapper__scroll) {
    display: none !important;
  }
  .movements-table-host :deep(.v-data-table-footer) {
    padding-inline: 12px;
  }
}
@media (min-width: 960px) {
  .movements-mobile-list {
    display: none !important;
  }
}

.movements-mobile-card {
  position: relative;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.movements-mobile-card__date {
  height: auto !important;
  min-height: 0 !important;
  font-size: 0.7rem !important;
  text-transform: none;
  letter-spacing: normal;
  align-self: flex-start;
  max-width: 100%;
}
.movements-mobile-card--selected {
  outline: 2px solid rgb(var(--v-theme-primary));
}
.movements-mobile-card__main {
  display: flex;
  align-items: flex-start;
  padding: 8px;
  gap: 8px;
}
.movements-mobile-card__media {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.movements-mobile-card__image-btn {
  flex-shrink: 0;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.movements-mobile-card__img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 4px;
  background: #212121;
  display: block;
}
.movements-mobile-card__qr-btn {
  min-width: 72px;
  margin-top: 2px;
  padding: 4px 8px;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  background: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.2;
  color: #424242;
  cursor: pointer;
  text-align: center;
}
.movements-mobile-card__info {
  flex: 1;
  min-width: 0;
  padding-bottom: 36px;
  padding-right: 4px;
}
.movements-mobile-card__status {
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 1;
  height: auto !important;
  min-height: 0 !important;
  font-size: 15px !important;
  text-transform: none;
  letter-spacing: normal;
  max-width: calc(100% - 96px);
}
</style>
